export default function isClinicalTrialSite(siteValue: string) {
  try {
    const siteArray = (process.env.NEXT_PUBLIC_CLINICAL_TRIALS_SITE || 'ClinicalResearch')?.split(
      '|'
    );
    if (siteArray?.includes(siteValue)) {
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
}

/** Mega screener tenant key from merged site settings (partial settings override). Omit when empty. */
export function getMegaScreenerTenantKey(siteSettings: any): string | undefined {
  const value = siteSettings?.megaScreenerTenantKey?.value;
  if (value == null || value === '') {
    return undefined;
  }
  return String(value);
}

export function isMegaScreenerStudy(siteSettings: any): boolean {
  const megaScreenerTenantKey = siteSettings?.megaScreenerTenantKey?.value;
  if (megaScreenerTenantKey == null || megaScreenerTenantKey === '') {
    return false;
  }
  return true;
}
